import {
	GET_RECOMMENDED_ITEMS,
	GET_RECOMMENDED_ITEMS_SUCCESS,
	GET_RECOMMENDED_ITEMS_FAIL,
	CLEAR_RECOMMENDED_ITEMS,
} from "./actionTypes";

import { GET_RECOMMENDED_ITEMS_URL } from "../../configs";
import Axios from "axios";

export const getRecommendedItems = (restaurantId, limit = 10) => (dispatch) => {
	dispatch({ type: GET_RECOMMENDED_ITEMS });

	return Axios.post(GET_RECOMMENDED_ITEMS_URL, {
		restaurant_id: restaurantId,
		limit: limit,
	})
		.then((response) => {
			if (response.data.success) {
				dispatch({
					type: GET_RECOMMENDED_ITEMS_SUCCESS,
					payload: {
						items: response.data.items,
						itemTagsByItem: response.data.itemTagsByItem,
					},
				});
				return response.data.items;
			} else {
				dispatch({
					type: GET_RECOMMENDED_ITEMS_FAIL,
					payload: response.data.message,
				});
				return {};
			}
		})
		.catch((error) => {
			console.error("Error fetching recommended items:", error);
			dispatch({
				type: GET_RECOMMENDED_ITEMS_FAIL,
				payload: error.message,
			});
			return {};
		});
};

export const clearRecommendedItems = () => (dispatch) => {
	dispatch({ type: CLEAR_RECOMMENDED_ITEMS });
};

